import {requestSaveJob} from "@app/services/JobService";
import {ResponseCode} from "@app/constants/Common";
import {toast} from "react-toastify";
import {alertMessage, Messages} from "@app/constants/Messages";

export const callApiSaveJob = (requestBody, callback) => {
    requestSaveJob(requestBody).then((res) => {
        if (res.sts_code === ResponseCode.SUCCESS) {
            toast.success(Messages.saveInfoSuccess)
        } else {
            alertMessage(res.sts_code, true, true)
        }
        return callback(res)
    }).catch((error) => {
        console.log(`Error:${JSON.stringify(error)}`);
    }).finally(() => {
    });

}
